export {default as voronoi} from "./voronoi";



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/dashboard/~/d3-voronoi/src/index.js
// module id = ../../../dashboard/node_modules/d3-voronoi/src/index.js
// module chunks = 1